import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useEffect } from "react";
import { useState } from "react";

const CheckoutForm = ({ booking }) => {
  const [cardError, setCardError] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [success, setSuccess] = useState('');
  const [processing, setProcessing] = useState(false);
  const [transactionId, setTransactionId] = useState('');
  const stripe = useStripe();
  const elements = useElements();
  const { price, email, patient, _id } = booking;

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch("https://doctors-portal-client-server-developertanbir-gmailcom.vercel.app/create-payment-intent", {
      method: "POST",
      headers: {
         "Content-Type": "application/json",
         authorization: localStorage.getItem("token") 
        },
      body: JSON.stringify({ price }),
    })
      .then((res) => res.json())
      .then((data) => setClientSecret(data.clientSecret));
  }, [ price]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    const card = elements.getElement(CardElement);

    if (card == null) {
      return;
    }

    // Use your card Element with other Stripe.js APIs
    const { error } = await stripe.createPaymentMethod({
      type: "card",
      card,
    });

    if (error) {
      console.log("[error]", error);
      setCardError(error.message);
    } else {
      setCardError("");
    }
    setSuccess('');
    setProcessing(true);

    const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(
        clientSecret,
        {
            payment_method: {
                card: card,
                billing_details: {
                    name: patient,
                    email: email
                },
            },
        },
    );

    if (confirmError) {
        setCardError(confirmError.message);
        return;
    }

    if (paymentIntent.status === "succeeded") {
        console.log('card info', card);
        // store payment info in the database
        const payment = {
            price,
            transactionId: paymentIntent.id,
            email,
            bookingId: _id
        }
        fetch('https://doctors-portal-client-server-developertanbir-gmailcom.vercel.app/payments', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
                authorization: localStorage.getItem('token')
            },
            body: JSON.stringify(payment)
        })
            .then(res => res.json())
            .then(data => {
                console.log(data);
                if (data.insertedId) {
                    setSuccess('Congrats! your payment completed');
                    setTransactionId(paymentIntent.id);
                }
            })
    }
    setProcessing(false);

    console.log(paymentIntent)
  };
  return (
    <>
      <form onSubmit={handleSubmit}>
        <CardElement
          options={{
            style: {
              base: {
                fontSize: "16px",
                color: "#424770",
                "::placeholder": {
                  color: "#aab7c4",
                },
              },
              invalid: {
                color: "#9e2146",
              },
            },
          }}
        />
        <button
          type="submit"
          className="btn btn-sm btn-primary my-4"
          disabled={!stripe || !clientSecret || processing}
        >
          Pay
        </button>
      </form>
      <p className="text-red-500">{cardError}</p>
      {
                success && <div>
                    <p className='text-green-500'>{success}</p>
                    <p>Your transactionId: <span className='font-bold'>{transactionId}</span></p>
                </div>
            }
    </>
  );
};

export default CheckoutForm;
